<template>
  <div
    ref="scroll"
    :class="[$style.standart_columns_list, 'gantt_scroll']"
    :style="{height: height}"
    @scroll="onScroll"
  >
    <div
      v-for="(cols, groupName) in columns"
      :key="groupName"
      :class="$style.standart_columns_list__group"
    >
      <div :class="$style.title">
        <div>
          {{ locales(`standart_columns_group_${groupName}`) }}
        </div>
        <span :class="$style.line" />
      </div>
      <div
        v-for="(item, index) in cols"
        :key="index"
        :class="$style.item"
      >
        <div :class="$style.standart_column_row">
          <tooltip
            :class="$style.tooltip_wrapper"
            :content="item.tooltip"
            :position="'left'"
            :interactive="true"
            :with-animation="false"
            :fallback-placements="[]"
          >
            <template #body>
              <svg-sprite
                :name="item.icon"
              />
              <div :class="$style.name">
                {{ item.value }}
              </div>
            </template>
          </tooltip>
          <div :class="$style.right_side">
            <div
              v-if="item.id === 'total_price'"
              :class="$style.edit"
            >
              <vgp-button
                :label="locales('currency_column_edit')"
                type="text-grey"
                :icon="{name: 'pensil', size: 16}"
                icon-side="right"
                :small="true"
                @onClick="openBudgetEditor"
              />
            </div>
            <div :class="$style.checkbox">
              <vgp-checkbox
                :size="16"
                :checked="Boolean(item.enabled)"
                @update:checked="onChange($event, item)"
              />
            </div>
          </div>
        </div>
        <div
          v-if="item.option"
          :class="[$style.standart_column_row, $style.advanced_option, !item.enabled ? $style.advanced_option__disable: '']"
        >
          <svg-sprite
            :name="item.optionIcon"
          />
          <div :class="$style.name">
            {{ item.optionValue }}
          </div>
          <div :class="$style.checkbox">
            <vgp-checkbox
              :size="16"
              :is-disable="!item.enabled"
              :checked="Boolean(item.enabledOption)"
              @update:checked="onChangeOption($event, item)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vgpCheckbox from '../../../common/VueComponents/checkbox/vgpCheckbox.vue';
import vgpButton from '../../../common/VueComponents/globalButton/vgpButton.vue';
import svgSprite from '../../../common/VueComponents/VueIcon/svgSprite.vue';
import tooltip from '../../../common/VueComponents/tooltips/tooltip.vue';

export default {
  name: 'ColumnsBarStandartColumnsTab',
  components: {
    svgSprite, vgpCheckbox, vgpButton, tooltip,
  },
  props: {
    columns: { type: [Array, Object], required: true, default: () => [] },
    isEditable: { type: Boolean, required: false },
  },
  emits: {
    changeCheckbox: Object,
    changeCheckboxOption: Object,
    openEditBar: Object,
    showGradient: null,
  },
  data() {
    return {
      locales: __,
      height: 0,
    };
  },
  mounted() {
    setTimeout(() => this.calcHeight(), 0);
  },
  beforeUnmount() {
  },
  methods: {
    calcHeight() {
      if (this.height === 0) {
        const appHeader = document.documentElement.querySelector('#header');
        const sidebarHeader = document.documentElement.querySelector('#columns_sidebar_hedaer');
        // const appFooter = 0;
        const clientHeight = document.documentElement.clientHeight;

        this.height = `${clientHeight - appHeader.clientHeight - sidebarHeader.clientHeight}px`;
      }
    },
    onScroll() {
      const element = this.$refs.scroll;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      if (scrollTop + clientHeight + 20 >= scrollHeight) {
        this.$emit('showGradient', false);
      } else {
        this.$emit('showGradient', true);
      }

      document.querySelectorAll('[data-tippy-root]').forEach(elem => {
        elem._tippy.hide();
      });
    },
    onChange(e, column) {
      this.$emit('changeCheckbox', {
        id: column.id,
        value: !column.enabled,
        group: column.group,
      });
    },
    onChangeOption(e, column) {
      this.$emit('changeCheckboxOption', {
        id: column.id,
        value: !column.enabledOption,
        group: column.group,
      });
    },
    openBudgetEditor() {
      this.$emit('openEditBar', { currency: true });
    },
  },
};
</script>

<style module src='./standartColumnsTab.less'></style>
